export const RequestBudgetTokenAuth = {
    HeaderName: "RequestBudget",
};
